import React from "react";
import { Layers, Droplets, Ruler, Sparkles } from "lucide-react";
import { Reveal } from "../Reveal";
import { useLang } from "../../i18n/LanguageContext";

const icons = [Layers, Droplets, Ruler, Sparkles];

export const WhatIsODF = () => {
  const { t } = useLang();
  return (
    <section className="bg-white py-28 md:py-36 border-t border-black/5" data-testid="home-what-is-odf">
      <div className="max-w-[1320px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
          <Reveal className="lg:col-span-4">
            <p className="eyebrow-dark">{t.whatIsOdf.eyebrow}</p>
            <h2 className="mt-5 text-3xl md:text-4xl font-light tracking-tight text-[#061A26]">
              {t.whatIsOdf.title}
            </h2>
            <p className="mt-6 text-base text-slate-600 leading-relaxed">{t.whatIsOdf.copy}</p>
            <div className="mt-10 film-stack" aria-hidden="true">
              <span /><span /><span />
            </div>
          </Reveal>
          <div className="lg:col-span-7 lg:col-start-6 grid grid-cols-1 sm:grid-cols-2 gap-px bg-black/5 border border-black/5">
            {t.whatIsOdf.benefits.map((b, i) => {
              const Icon = icons[i];
              return (
                <Reveal key={b.title} delay={i * 0.1} y={16} className="bg-white p-9 md:p-11 group hover:bg-[#DFF7F5]/30 transition-colors duration-500" data-testid={`odf-benefit-${i}`}>
                  <Icon size={22} strokeWidth={1.5} className="text-[#19C7C1]" />
                  <h3 className="mt-5 text-base md:text-lg font-semibold text-[#061A26]">{b.title}</h3>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed">{b.desc}</p>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
